/**
 * SliderInput — gentle 1–N emotional scale.
 * Sliders never reveal any "score" — labels are purely qualitative.
 */
import { useEffect } from "react";

export default function SliderInput({ question, value, onChange }) {
  const min = question.scale_min ?? 1;
  const max = question.scale_max ?? 5;
  const labels = question.scale_labels || {};
  const mid = Math.round((min + max) / 2);
  const current = typeof value === "number" ? value : mid;

  // Seed the answer buffer with the midpoint so the slider always satisfies
  // the canContinue guard, even if the user doesn't touch it.
  useEffect(() => {
    if (typeof value !== "number") onChange(mid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="kcis-slider px-1" data-testid={`q-${question.id}-slider`}>
      <input
        type="range"
        min={min}
        max={max}
        value={current}
        onChange={(e) => onChange(Number(e.target.value))}
        aria-label={question.prompt}
        data-testid={`q-${question.id}-range`}
      />
      <div className="mt-3 flex items-center justify-between text-xs text-slate-500">
        <span>{labels.low || min}</span>
        <span className="kcis-assessment-overline" data-testid={`q-${question.id}-current`}>
          {current}
        </span>
        <span>{labels.high || max}</span>
      </div>
    </div>
  );
}
